import { AxiosPromise } from 'axios'
import { AuditDataType } from 'types/api/faber/customerAuditLog.type'
import {
  BillWaiverAuditLogType,
  GeneralAuditResponseType,
  VoucherAuditLogType
} from 'types/api/faber/customerAuditLog.type'

import FaberApi from '.'

class CustomerLogApi {
  /**
   * to see all logs for one customer
   */
  static getCustomerLogs(
    userID: string,
    faberToken: string
  ): AxiosPromise<AuditDataType> {
    return FaberApi.httpGet(
      `/audit/subscriptions/v2/${userID}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }
  static getSmartDelayForms(userId: string, faberToken: string) {
    return FaberApi.httpGet(
      `/benefit/smartdelay/records/retrieval/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getVoucherLogs(
    userId: string,
    faberToken: string
  ): AxiosPromise<GeneralAuditResponseType<VoucherAuditLogType[] | undefined>> {
    return FaberApi.httpGet(
      `/audit/vouchers/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getWaiverLogs(
    userID: string,
    faberToken: string
  ): AxiosPromise<
    GeneralAuditResponseType<BillWaiverAuditLogType[] | undefined>
  > {
    return FaberApi.httpGet(
      `/audit/waivers/v2/${userID}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }
}

export default CustomerLogApi
